<template>
  <!-- 常见问题 -->
  <div class="help_center_fqa">
    <!-- 横幅搜索 -->
    <div class="help_banner">
      <el-input placeholder="请输入您想搜索的内容" v-model="searchObj.name" class="input-with-search"
                @keyup.enter.native="search">
        <el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="help_center_content m">
      <!-- 左边菜单 -->
      <div class="faq_left_menu">
        <el-menu
            :default-openeds="defopen"
            class="el-menu-vertical-demo" @select="selectMenu">
          <template v-for="item,index in types">
            <!--        有子字典-->
            <template v-if="item.child && item.child.length > 0">
              <el-submenu :index="item.code">
                <template slot="title">
                  <span>{{item.name}}</span>
                </template>

                <el-menu-item v-for="it in item.child" :index="it.code">
                  {{it.name}}
                </el-menu-item>
              </el-submenu>
            </template>
            <!--  没有子字典  -->
            <template v-else>
              <el-menu-item :index="item.code">{{item.name}}</el-menu-item>
            </template>
          </template>

        </el-menu>
      </div>
      <!-- 右边列表 -->
      <div class="faq_right_list">
        <div class="right_list">
          <div class="question_content_l">
            <router-link class="question_content_li" v-for="item,index in list"
                         :to="{path: '/personal_center/help/detail',query:{id:item.id}}">
              <div class="question_tit">
                <i class="iconfont q">Q</i>
                <a
                >{{item.name}}
                </a>
              </div>
              <div class="question_answer">
                {{item.synopsis}}
              </div>
            </router-link>
          </div>
        </div>
        <div class="page" v-if="list.length > 0">
          <el-pagination
              background
              :current-page="page.pageNo"
              layout="prev, pager, next"
              :total="page.total"
              :page-size="page.pageSize"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      types: [],
      defopen: ['ParkHelpCenterFrontBasics'],
      searchObj: {
        type: 'ParkHelpCenterFront',
        class_one: '',
        class_two: '',
        name: '',
        sort: 'SortDefault'
      },
      page: {
        pageNo: 0,
        pageSize: 10,
        total: 0
      },
      list: [],
    }
  },
  created() {
    this.getDictionaryCode();
    this.getList();
  },
  methods: {
    //查询字典树
    getDictionaryCode() {
      this.api
          .getDictionaryCode({
            code: 'ParkHelpCenterFront'
          })
          .then(res => {
            if (res.error['err_code'] !== 0) return
            let obj = res.obj.list[0] || {}
            this.types = obj.child || []
          })
    },
    selectMenu(index, indexPath) {
      this.searchObj.class_one = indexPath[0]
      this.searchObj.class_two = indexPath[1]
      this.search()
    },
    search() {
      this.page.pageNo = 0;
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getList();
    },
    //获取帮助文档
    getList() {
      let params = {
        ...this.searchObj,
        ...this.page
      }
      this.api.getNews(params).then(res => {
        if (res.error['err_code'] !== 0) return
        this.list = res.obj.list
        this.page.total = res.obj.totalSize
      })
    }
  }
}
</script>

<style lang="scss">
.help_center_fqa {
  background-color: #fff;
  .help_banner {
    width: 100%;
    height: 200px;
    background-color: #333333;
    background-image: url("~@/assets/img/about_us/help_banner.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .input-with-search {
      width: 660px;
      height: 46px;
      border-radius: 0px;
      border: 1px solid #4C84FF;
      box-sizing: border-box;
      input {
        height: 100%;
        border: none;
        border-radius: 0;
      }
    }
    .input-with-search .el-input-group__append {
      overflow: hidden;
      border: none;
    }
    .input-with-search .el-input-group__append {
      padding: 0px;
      width: 100px;
      background-color: #4C84FF;
      border-radius: 0px;
    }
    .input-with-search .el-input-group__append > button {
      width: 100%;
      height: 46px;
      background-color: #4C84FF;
      color: #FFFFFF;
      font-size: 18px;
      border: 1px solid #4C84FF;
      margin: 0px;
    }
  }
  .help_center_content {
    padding-top: 30px;
    padding-bottom: 50px;
    display: flex;
    justify-content: space-between;
    .faq_left_menu {
      width: 200px;
      box-sizing: border-box;
      .el-menu-vertical-demo {
        border: 1px solid #E7E9EC;
        box-sizing: border-box;
      }
      .el-menu-vertical-demo > .el-submenu,
      .el-menu-vertical-demo > .el-menu-item {
        border-bottom: 1px solid #E7E9EC;
        overflow: hidden;
      }
      .el-submenu .el-menu-item {
        padding: 0 30px !important;
        color: #999999;
      }
      .el-menu-item.is-active {
        color: #4C84FF;
      }
      .el-menu-vertical-demo > .el-submenu > .el-submenu__title,
      .el-menu-vertical-demo > .el-menu-item {
        height: 50px;
        line-height: 50px;
      }
      .link {
        display: block;
        color: #999999;
        width: 100%;
        height: 100%;
      }
      .el-menu-vertical-demo > li:last-child {
        border-bottom: 0;
      }
      .el-menu-vertical-demo > .el-submenu > .el-menu > .is-active {
        border-left: 2px solid #4C84FF;
        background: rgba(76, 132, 255, 0.12);
        margin-left: -2px;
      }
    }
    .faq_right_list {
      .right_list {
        width: 970px;
        .question_content_l {
          flex-basis: 676px;
        }
        .question_content_li {
        }
        .question_tit {
          display: flex;
          align-items: center;
          height: 32px;
          line-height: 32px;
          /*cursor: pointer;*/
          a {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-left: 8px;
          }
          .q {
            width: 21px;
            height: 13px;
            font-size: 6px;
            line-height: 13px;
            text-align: center;
            background-color: #4C84FF;
            color: #ffffff;
            position: relative;
            vertical-align: middle;
          }
          .q:before {
            content: '';
            width: 5px;
            height: 7px;
            background-color: #4C84FF;
            position: absolute;
            bottom: -5px;
            left: 0px;
          }
          .q:after {
            content: '';
            width: 5px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            bottom: -8px;
            left: 2px;
            transform: rotate(45deg);
          }
        }
        .question_answer {
          /*height: 84px;*/
          line-height: 24px;
          padding: 3px 0 12px 33px;
          font-size: 14px;
          color: #999999;
          box-sizing: border-box;
        }
        .link {
          display: inline-block;
          color: #3282FF;
          margin-left: 10px;
        }
      }
      .page {
        display: flex;
        justify-content: center;
        width: 100% !important;
        margin-top: 30px;
      }
    }
  }
}
</style>
